export default {
  languageOptionsLabel: '选择预览语言',
  playAgainBtn: '重玩',
  navbar: {
    backEdit: '返回编辑',
    openBrowser: '在浏览器中打开',
    logoTitle: '返回我的项目',
  },
}
